import { Link } from 'react-router-dom';
import { useLang } from '@/i18n/LanguageContext';

export default function FooterV2() {
  const { t } = useLang();
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="foot-bottom">
          <span className="fineprint">
            {t('footer.copy.pre')}
            <Link to="/privacy" className="foot-legal">
              {t('footer.privacy')}
            </Link>
            {t('footer.copy.post')}
          </span>
        </div>
      </div>
    </footer>
  );
}
